import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";

export const dashBoardApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchPieChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/pie-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['pieChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchBarChartData: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/receiving-data/bar-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['barChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/receiving-data/employees-data/store`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employeeReceiving'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee Data")
            },

        }),
    }),

});

export const {
    useSearchPieChartDataQuery,
    useSearchBarChartDataQuery,
    useCreateEmployeeDataMutation,
} = dashBoardApi;

